import React, { useState, useEffect } from "react";
import "./style.css";
import { getDelawareDate } from "../env";
import { useNavigate, useLocation } from "react-router";
import { IoArrowBackOutline } from "react-icons/io5";
import icon from "../assets/Icon.png";
import { url } from "../env";
import Loader from "../components/loader";
import Footer from "../components/footer";
import PopUp from "../components/popUp";
import PopUp2 from "../components/popUp2";

export default function CourseDetails() {
    const location = useLocation();
    const state = location.state;
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [allStudents, setAllStudents] = useState([]);
    const [students, setStudents] = useState([]);
    const [attendanceFilterPopUp, setAttendanceFilterPopUp] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState("");
    const [selectedStudentName, setSelectedStudentName] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("");
    const [popupActive, setPopUpActive] = useState({
        active: false,
        type: "error",
        title: "Alert",
        description: "alert"
    })
    const [courseStartDate,setCourseStartDate] = useState(null);


    useEffect(() => {
        if (popupActive.active) {
            const timer = setTimeout(() => {
                setPopUpActive((prevState) => ({
                    ...prevState,
                    active: false,
                    type: "",
                    title: "",
                    description: ""
                }));
            }, 4000);

            return () => clearTimeout(timer);
        }
    }, [popupActive.active]);


    const fetchAllStudents = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${url}course-registration/get/${location.state.courseId}`);
            const result = await response.json();
            setAllStudents(result.registrations);
            setCourseStartDate(result.startDate);
            console.log(allStudents, "allstudents")
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllStudents();
    }, []);

    function getLastThreeDigits(id) {
        const parts = id.split('-');
        return parts[parts.length - 1];
    }
    const checkAttendance = async (courseId, attendanceDate) => {
        setLoading(true);
        try {
            const response = await fetch(
                `${url}course-attendance/check-attendance?courseId=${courseId}&attendanceDate=${attendanceDate}`
            );
            const result = await response.json();
            setLoading(false);

            if (response.ok && result.attendanceTaken !== undefined) {
                if (result.attendanceTaken === false) {
                    setStudents(result.students);
                } else {
                    setStudents([]);
                }
                return result.attendanceTaken;
            } else {
                console.error("Unexpected API response:", result);
                return false;
            }
        } catch (error) {
            console.error("Error fetching attendance data:", error);
            setLoading(false);
            return false;
        }
    };

    const moveToAttendance = async (courseId, courseName) => {
        const isAttendanceTaken = await checkAttendance(courseId, getDelawareDate());

        if (isAttendanceTaken === false) {
            setStudents((prevStudents) => {
                const studentsToPass = prevStudents.length > 0 ? prevStudents : [];
                navigate("/attendance", {
                    state: {
                        attendanceDate: getDelawareDate(),
                        courseId: courseId,
                        students: studentsToPass,
                        courseName: courseName
                    },
                });
                return studentsToPass;
            });
        } else {
            setPopUpActive({
                active: true,
                type: "warning",
                title: "Alert",
                description: `Attendance already has been taken for ${getDelawareDate()}.`
            })
        }
    };

    const closeAttendanceFilter = () => {
        setAttendanceFilterPopUp(false)
    }


    


    const fetchStudentMonthlyReport = async () => {
        setLoading(true);
        try {
            if (selectedMonth!==""&& selectedStudent!=="") {
                const response = await fetch(`${url}course-attendance/get-attendance?courseId=${location.state.courseId}&studentId=${selectedStudent}&month=${selectedMonth}`);
                const result = await response.json();
                if(response.ok){
                    navigate("/student", {
                        state: {
                            month: selectedMonth,
                            id: selectedStudent,
                            attendance: result.studentAttendance,
                            totalPresent: result.totalPresents,
                            totalAbsent:result.totalAbsents,
                            name:selectedStudentName,
                            courseName:location.state?.courseName
                        },
                    });
                    setLoading(false);
                }
            }
            
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        }
    };


    return (
        <div className="course_details_page" style={{paddingBottom:"40px"}}>
            <div className="mainAttendanceHeader_1">
                <div className="title">
                    <span className="date">{getDelawareDate()}</span>
                    <span className="courseName">
                        {location.state?.courseName}
                        {/* County */}
                    </span>
                </div>
                <div onClick={() => navigate(-1)} className="back_arrow">
                    <IoArrowBackOutline />
                </div>
                <div className="profile_icon">
                    <img src={icon} alt="" srcset="" />
                </div>

                <div className="btns_set">
                    <div className="btn_1" onClick={() => { moveToAttendance(location.state.courseId, location.state.courseName) }}>
                        Attendance
                    </div>

                    <div className="btn_1" onClick={() => { setAttendanceFilterPopUp(true) }}>
                        Monthly Report
                    </div>
                </div>


            </div>
            <div className="studentsTableHeading">
                <span className="studentTableNameHeading">Student Name</span>
                <span className="studentTableRollHeading">Roll No.</span>
                <span className="studentTableContactHeading">Contact</span>
            </div>

            {allStudents && allStudents.map((item) => {
                return (
                    <div className="attendanceTab" key={item.regId}>
                        <span className="studentName"> <span className={item.invoiceStatus === "paid" ? "paid" : "unpaid"}></span> {item.name}</span>
                        <span className="studentRoll">
                            <div className="roll_no">{getLastThreeDigits(item.regId)}</div>
                        </span>
                        <span className={`studentStatus`}>
                            {item.contact ? item.contact : "N/A"}
                        </span>
                    </div>
                );
            })}



            {loading && <Loader />}
            {popupActive.active && <PopUp type={popupActive.type} title={popupActive.title} description={popupActive.description} />}
            {attendanceFilterPopUp && (
                <PopUp2
                    closePopUp={closeAttendanceFilter}
                    studentList={allStudents.map((student) => ({
                        label: student.name,
                        value: student.regId,
                    }))}
                    startDate={courseStartDate}
                    selectedMonth={selectedMonth}
                    selectedStudent={selectedStudent}
                    setSelectedMonth={setSelectedMonth}
                    setSelectedStudent={setSelectedStudent}
                    setSelectedStudentName={setSelectedStudentName}
                    navigateToReport={fetchStudentMonthlyReport}

                />
            )}

            {/* <Footer /> */}
        </div>
    )
}

